import { useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const Field = ({ label, testid, ...p }) => (
  <label className="block"><span className="text-xs font-medium text-slate-600">{label}</span>
    <input className="mt-1 w-full border border-slate-200 rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:border-slate-900" data-testid={testid} {...p} /></label>
);

export default function AccountSettings() {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ email: user?.email || "", current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password && f.new_password !== f.confirm) return toast.error("Le due nuove password non coincidono");
    setBusy(true);
    try {
      const { data } = await api.put("/auth/account", { current_password: f.current_password, email: f.email, new_password: f.new_password || null });
      setUser(data);
      setF({ email: data.email, current_password: "", new_password: "", confirm: "" });
      toast.success("Dati di accesso aggiornati");
    } catch (err) { toast.error(formatErr(err)); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="max-w-md space-y-5 bg-white border border-slate-200 rounded-lg p-6" data-testid="account-form">
      <div><h2 className="text-lg font-semibold">Accesso al gestionale</h2><p className="text-sm text-slate-500 mt-1">Cambia l'email o la password con cui entri. Per sicurezza serve la password attuale.</p></div>
      <Field label="Email di accesso" type="email" required value={f.email} onChange={set("email")} testid="account-email-input" autoComplete="username" />
      <Field label="Nuova password (lascia vuoto per non cambiarla)" type="password" minLength={8} value={f.new_password} onChange={set("new_password")} testid="account-new-password-input" autoComplete="new-password" placeholder="Almeno 8 caratteri" />
      {f.new_password && <Field label="Ripeti la nuova password" type="password" required value={f.confirm} onChange={set("confirm")} testid="account-confirm-password-input" autoComplete="new-password" />}
      <Field label="Password attuale *" type="password" required value={f.current_password} onChange={set("current_password")} testid="account-current-password-input" autoComplete="current-password" />
      <button disabled={busy} className="bg-slate-900 text-white text-sm px-5 py-2.5 rounded-md disabled:opacity-50" data-testid="account-save-btn">{busy ? "Salvataggio..." : "Salva modifiche"}</button>
    </form>
  );
}
